import { FunctionalComponent, h, Fragment, ComponentChildren } from "preact";
import { LogoFixedIcon } from "../../icons/LogoFixed";
import { useState } from "preact/hooks";
import { CutleryIcon } from "../../icons/CutleryIcon";
import { LocationPinIcon } from "../../icons/LocationPinIcon";
import {
  ChildrenContainerStyle,
  ContainerStyle,
  DelTacoLogo,
  GlobalNav,
  GlobalSubNav,
  IconWrapper,
  LogoStyle,
  MenuNav,
  OrderNav,
} from './DelTacoNav.style';
import { DelTacoFooter } from '../del-taco-footer/DelTacoFooter';
import { Helmet } from 'react-helmet';
import { link } from "@authentic/loyalty-pwa/util";

interface DelTacoNavProps {
  title?: string; // this is the title (string) used to set on the <title>Title Page</title> into html code
  children?: ComponentChildren;
}
export const DelTacoNav: FunctionalComponent<DelTacoNavProps> = ({
  title,
  children,
}) => {
  const [isActive, setActive] = useState(false);

  const showMenu = (e: any) => {
    setActive(!isActive);
  };

  return (
    <Fragment>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ContainerStyle>
        <button
          id="nav-toggle"
          className={isActive ? "active" : ""}
          onClick={showMenu}
        >
          <span />
        </button>

        <IconWrapper>
          <a href={"https://deltaco.com/menu"}>
            <CutleryIcon />
          </a>
          <a href={"https://locations.deltaco.com/search"}>
            <LocationPinIcon />
          </a>
        </IconWrapper>

        <DelTacoLogo>
          <a href="https://deltaco.com" style={{ height: 60 }}>
            <LogoStyle
              src={"https://deltaco.com/images/main-logo.svg"}
              alt={"Del Taco"}
            />
          </a>
        </DelTacoLogo>
        <MenuNav className={isActive ? "active" : ""}>
          <GlobalSubNav className={isActive ? "active" : ""}>
            <li>
              <a href="https://deltaco.wgiftcard.com/responsive/landing_responsive/landing/deltaco" className="nav-giftcards" target="_blank">
                Gift Cards
              </a>
            </li>
            <li>
              <a href="https://deltaco.com/contactus" className="nav-giftcards" target="_blank">
                Contact Us
              </a>
            </li>
          </GlobalSubNav>

          <GlobalNav className={isActive ? "active" : ""}>
            <li>
              <a href="https://deltaco.com/menu" className="nav-menu">
                Menu
              </a>
            </li>
            <li>
              <a href="https://deltaco.com/careers" className="nav-careers">
                Careers
              </a>
            </li>
            <li style={{ textAlign: "center" }}>
              <a
                style={{ padding: "0", paddingTop: "5px", width: "120px" }}
                href={link('/')}
                aria-label="Del Yeah! Rewards Page"
                className="nav-careers"
              >
                <LogoFixedIcon />
              </a>
            </li>
            <li>
              <a
                href="https://deltacofranchise.com/"
                target="_blank"
                className="nav-franchising"
              >
                Franchising
              </a>
            </li>
            <li>
              <a
                href="https://deltacowebstore.com/"
                target="_blank"
                className="gtm_nav-webstore"
              >
                Webstore
              </a>
            </li>
            <li>
              <a
                href="https://locations.deltaco.com/search"
                className="gtm_nav-webstore"
              >
                Locations
              </a>
            </li>
          </GlobalNav>

          <OrderNav className={isActive ? "active" : ""}>
            <li>
              <a href={link('/order')}>
                Order Ahead Or Delivery
              </a>
            </li>
          </OrderNav>
        </MenuNav>
      </ContainerStyle>
      <ChildrenContainerStyle >
        {children}
      </ChildrenContainerStyle>
      <div style={{paddingBottom: '10px', borderTop: '2px solid black'}}>
        <DelTacoFooter/>
      </div>
    </Fragment>
  );
};
